import React, { useEffect, useRef } from 'react';

export default function InfiniteScroll({
	onIntersect
}: {
	onIntersect: () => void;
}) {
	const loader = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(entries => {
			const first = entries[0];
			if (first.isIntersecting) {
				onIntersect();
			}
		});

		const currentLoader = loader.current;
		if (currentLoader) {
			observer.observe(currentLoader);
		}

		return () => {
			if (currentLoader) {
				observer.unobserve(currentLoader);
			}
		};
	}, [loader.current]);

	return <div className="h-1 flex-shrink-0" ref={loader} />;
}
